"use client";

import {useEffect} from "react";
import {useOpenDialog} from "@/lib/dialog-orchestrator/react";
import {DialogsEnum} from "@/lib/enums/DialogsEnum";
import {AUTH_QUERY_PARAM, authTabFromQuery} from "@/lib/utils/contants/authQuery";

/**
 * Progressive-enhancement bridge for the header auth CTAs (AC-729).
 *
 * The Register/Login CTAs are real `<a href="?auth=…">` links so a tap that
 * lands before hydration still navigates instead of being silently dropped on
 * slow WebViews. On load this reads that param, opens the AUTH dialog, then
 * strips the param so a refresh/back-nav doesn't re-open it. The AUTH dialog's
 * own `canShow` gate ignores authenticated users, so no auth check is needed
 * here.
 */
export const AuthUrlOpener = () => {
    const openDialog = useOpenDialog();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = authTabFromQuery(params.get(AUTH_QUERY_PARAM));
        if (!tab) return;

        openDialog(DialogsEnum.AUTH, {props: {tab}});

        params.delete(AUTH_QUERY_PARAM);
        const query = params.toString();
        const url =
            window.location.pathname + (query ? `?${query}` : "") + window.location.hash;
        window.history.replaceState(window.history.state, "", url);
    }, [openDialog]);

    return null;
};
